import { render, staticRenderFns } from "./Iframe copy.vue?vue&type=template&id=26afefce&scoped=true&"
import script from "./Iframe copy.vue?vue&type=script&lang=js&"
export * from "./Iframe copy.vue?vue&type=script&lang=js&"
import style0 from "./Iframe copy.vue?vue&type=style&index=0&id=26afefce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26afefce",
  null
  
)

export default component.exports